import { Avatar, Box, Typography } from "@mui/material";

import ProfileCover from "../../assets/images/profile-cover.png";

import HeadingLoader from "./HeadingLoader";
import HeadingAction from "./HeadingAction";

interface HeadingProps {
  fullName: string;
  firstTwoChr: string;
  countryName: string;
  role: string;
  cityName: string;
  media?: string;
  isLoading: boolean;
  children?: React.ReactNode;
  isFollowing: boolean;
  onFollowToggle?: () => void;
  isEntityOwnProfile?: boolean;
}

const Heading = ({
  fullName,
  firstTwoChr,
  countryName,
  role,
  cityName,
  media,
  isLoading,
  children: TabsControl,
  isFollowing,
  onFollowToggle,
  isEntityOwnProfile,
}: HeadingProps) => {
  if (isLoading) {
    return <HeadingLoader />;
  }

  return (
    <Box sx={styles.container}>
      <Box sx={styles.headerContainer} />
      <Box sx={styles.contentContainer}>
        <Box sx={styles.contentHeaderContainer}>
          <Box sx={styles.contentHeaderAvatarContainer}>
            <Avatar sx={styles.contentHeaderAvatar} src={media}>
              {firstTwoChr}
            </Avatar>
          </Box>
          <Box>
            <Typography sx={styles.contentHeaderFullName}>{fullName}</Typography>
            <Typography sx={styles.contentHeaderRole}>
              {role} {role && (cityName || countryName) && " • "} {cityName && `${cityName}`}{" "}
              {countryName && `, ${countryName}`}
            </Typography>
          </Box>
          <HeadingAction
            isEntityOwnProfile={isEntityOwnProfile}
            isFollowing={isFollowing}
            onFollowToggle={onFollowToggle}
          />
        </Box>
        {TabsControl}
      </Box>
    </Box>
  );
};

export default Heading;

const styles = {
  container: {
    borderRadius: "8px",
    border: "1px solid #EAECF0",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#FFF",
  },
  headerContainer: {
    height: "145px",
    backgroundImage: `url(${ProfileCover})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    width: "100%",
  },
  contentContainer: { display: "flex", flexDirection: "column", gap: "32px", padding: "20px 20px 0" },
  contentHeaderContainer: { display: "flex", gap: "16px", flexWrap: "wrap" },
  contentHeaderAvatarContainer: { position: "relative", width: "110px" },
  contentHeaderAvatar: {
    width: "110px",
    height: "110px",
    borderRadius: "50%",
    border: "2px solid #FFF",
    position: "absolute",
    bottom: "0",
    left: "0",
  },
  contentHeaderFullName: {
    color: "var(--Gray-900, #101828)",
    fontFamily: "Montserrat",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "28px",
  },
  contentHeaderRole: {
    color: "var(--Dark---600, #707070)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
  },
};
